import React, { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Tag } from 'primereact/tag';

const TagControl = (props) => {
    const [tags, setTags] = useState(props.tags);
    const [newTag, setNewTag] = useState('');

    const addTag = (e) => {
        e.preventDefault();
        
        if (newTag.trim() && !tags.includes(newTag.trim())) {

            let input = newTag.trim();
            let newTags = [input];

            if (props.allowMultiple) {
                if (input.indexOf(',') > -1) {
                    newTags = input.split(',');

                    newTags = newTags
                        .map(item => item.trim())
                        .filter(item => item !== '');
                }
            }

            let tagList = [...tags, ...newTags];
            tagList = [...new Set(tagList)];

            setTags(tagList);
            if (props.onChange) props.onChange(tagList);
            setNewTag('');
        }
    };

    const removeTag = (tagToRemove) => {
        const tagList = tags.filter(tag => tag !== tagToRemove);
        setTags(tagList);
        if (props.onChange) props.onChange(tagList);
    };

    useEffect(() => {
        setTags(props.tags);
    }, [props.tags]);

    return (
        <div className="grid" style={{marginTop: 5, marginBottom: 5}}>
            <div className="col-12" style={{ display: 'flex', gap: 8, alignItems: 'center', maxWidth: 600, marginBottom: 5 }}>
                <InputText
                    value={newTag}
                    onChange={(e) => setNewTag(e.target.value)}
                    placeholder={props.placeholder}
                    onKeyDown={(e) => { if (e.code === "Enter") addTag(); }}
                    style={{ width: '70%' }}
                />
                <Button
                    label="Add"
                    onClick={addTag}
                    disabled={!newTag.trim()}
                    style={{ whiteSpace: 'nowrap', width: '30%' }}
                />
            </div>

            <div className="col-12">
                {tags.map((tag) => (
                    <Tag key={tag} style={{ minWidth: 200, marginRight: 5, marginBottom: 5 }} severity="success" onClick={() => removeTag(tag)}>
                        <div className="align-items-center">
                            <span style={{ margin: 5, fontSize: "medium" }}>{tag}</span>
                            <i className="pi pi-times text-xs"></i>
                        </div>
                    </Tag>
                ))}
            </div>
        </div>
    );
};

export default TagControl;